import React, { useEffect, useState } from 'react'
import { mdiPlus } from '@mdi/js'
import { useFormikContext } from 'formik'
import { createTableConfig } from '@components/Common/Table/scripts/tableConfig'
import { TableColumn, TableOption, TablePaginator, TableRow } from '@components/Common/Table'
import setClienteValues from '@modules/viagem/utils/setClienteValues'
import getEnderecoSearchCliente from '@modules/viagem/utils/getEnderecoSearchCliente'
import { tableViagemSearhClientColumns } from '@modules/viagem/constants/tableSearch'
import { searchDestinatario as requestSearch, searchCliente } from '@modules/viagem/controllers/viagemController'
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import { formatDocumento } from '@utils/format'
import FormSearchCliente from '../../FormSearchCliente'
import { ModalSearchClienteProps } from '../../../../interfaces/SearchClienteModal'

const TableDestinatario: React.FC<ModalSearchClienteProps> = ({ setOpen, type }) => {

    const dispatch = useAppDispatch()
    const { searchDestinatario } = useAppSelector(s => s.viagem)
    const { requestSearchDestinatario, requestSearchCliente } = useAppSelector(s => s.requestViagem)

    const [tableConfig] = useState(createTableConfig(
        'searchDestinatario',
        tableViagemSearhClientColumns
    ))

    const { setFieldValue } = useFormikContext()

    useEffect(() => {
        requestSearch(dispatch, '', setFieldValue, false)
    }, [])

    return (

        <>
            <TablePaginator
                data={searchDestinatario}
                loading={requestSearchCliente.loading || requestSearchDestinatario.loading}
                config={tableConfig}
                options={
                    <>
                        <div />
                        <FormSearchCliente
                            type={type}
                            handleSearchSistema={v => {
                                requestSearch(dispatch, v, setFieldValue, false)
                            }}
                            handleSearchDocumento={v => {
                                searchCliente(dispatch, v, setFieldValue, false, 'destinatario')
                            }}
                        />
                    </>
                }
                renderItem={(item, index) => (
                    <TableRow key={index}>
                        <TableColumn>{item.nome}</TableColumn>
                        <TableColumn width={160}>{formatDocumento(item.nroDocumento)}</TableColumn>
                        <TableColumn>{getEnderecoSearchCliente(item)}</TableColumn>
                        <TableColumn>
                            <TableOption
                                icon={mdiPlus}
                                status="success"
                                onClick={() => {
                                    setClienteValues('destinatario', item, setFieldValue)
                                    setFieldValue('particularidades', item?.particularidades)

                                    setOpen(false)
                                }}
                            />
                        </TableColumn>
                    </TableRow>
                )}
            />
        </>

    )

}

export default TableDestinatario